import { useTranslation } from 'react-i18next';

import { FormTextField } from '~/components/atoms/form-fields/FormTextField';
import ContentQRBuilderHeader from '~/components/builder/ContentQRBuilderHeader';
import NameAndOrganizationBlock from '~/components/builder/NameAndOrganizationBlock';
import QrTypeTopCard from '~/components/builder/QrTypeTopCard';
import Accordion from '~/components/ui/Accordion/Accordion';
import { QRCODE_STATIC_TYPE } from '~/constants/qr-code';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { StyledFormContainer } from '~/pages/qrBuilder/p-static/commonStyled';
// import PasswordProtectionBlock from '~/components/builder/PasswordProtectionBlock';

export const StaticTextForm = () => {
  const { t } = useTranslation();

  return (
    <StyledFormContainer>
      <ContentQRBuilderHeader />
      <QrTypeTopCard type={QRCODE_STATIC_TYPE.TEXT} />
      <CreateQRContentBlockLayout defaultExpanded type="basicInfo">
        <Accordion
          defaultExpanded
          variant="child"
          hideBottomBorder
          summary={t('staticQrTemplates:text:content:fields:text:title')}
          details={
            <FormTextField
              name="text"
              fullWidth
              label={t('staticQrTemplates:text:content:fields:text:label')}
              placeholder={t('staticQrTemplates:text:content:fields:text:placeholder')}
              inputProps={{ maxLength: 300 }}
              minRows={3}
              multiline
            />
          }
        />
      </CreateQRContentBlockLayout>
      <NameAndOrganizationBlock isStatic />
      {/*<PasswordProtectionBlock />*/}
    </StyledFormContainer>
  );
};
